var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.60f6e2964b892840fcf219c112947316.svg#y';
                    var viewUrl = 'sprites.60f6e2964b892840fcf219c112947316.svg#view-y';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 51 35',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };